import { makeStyles } from '@material-ui/core';

export const useExistingPlanChipStyles = makeStyles((theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '24px',
    padding: '0px 12px',
    border: `1px solid ${theme.palette.colors.redDark}`,
    borderRadius: '4px',
    backgroundColor: theme.palette.colors.redDark,
    boxSizing: 'border-box',
  },
  label: {
    color: theme.textWhite.main,
    fontFamily: 'Inter, sans-serif',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '700 !important',
    lineHeight: 'normal',
    letterSpacing: '0.32px',
    whiteSpace: 'nowrap',
  },
}));
